import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.5 0.5L13.5 13.5M13.5 0.5L0.5 13.5", stroke: "#8D8E90", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgClose;
